import styles from "./refinanceCalculatorResult.module.css";
import GetMonthlyPayment from "../../../helpers/monthlyPayment";
import GetTotalInterestTime from "../../../helpers/totalInterestTime";

const RefinanceCalculatorResult = ({ loan, year, rate, newRate, newYear }) => {
  let currentPay = GetMonthlyPayment(loan, rate, year);
  let newPay = GetMonthlyPayment(loan, newRate, newYear);
  let extra = currentPay - newPay;
  let savedYears = 0;
  let savedMonths = 0;

  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const USDollarNoCents = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  const currentTotalInterest = () => {
    let currentInterestTime = GetTotalInterestTime(loan, rate, year, extra);
    return currentInterestTime.totalInterest;
  };

  const newTotalInterest = () => {
    let newInterestTime = GetTotalInterestTime(loan, newRate, newYear, extra);
    let dif = year * 12 - newInterestTime.totalMonths;
    savedYears = Math.floor(dif / 12);
    savedMonths = dif % 12;
    return newInterestTime.totalInterest;
  };

  return (
    <div className={styles.result_view}>
      <div className="col-m-6">
        <label className={`form-label ${styles.label_main}`}>
          Monthly Savings
        </label>
        <div className={styles.payment_dif}>
          {USDollar.format(currentPay - newPay).toString()}
        </div>
      </div>

      <hr className={styles.hr} />

      <div className={`col-m-6 ${styles.saved}`}>
        <div>
          <div className={styles.rate_dif}>
            {USDollarNoCents.format(
              currentTotalInterest() - newTotalInterest()
            ).toString()}
            <span className={styles.interest_saved}> / interest saved</span>
          </div>
          <div className={styles.disclaimer}>
            Putting this back into your loan could save you this amount in
            interest over the life of your loan.
          </div>
        </div>

        <div>
          <div className={styles.rate_dif}>
            <span className={styles.saved_values}>{savedYears}</span>
            <span className={styles.stext}>{"year"}</span>
            <span className={styles.saved_values}>{savedMonths}</span>
            <span className={styles.stext}>{"months"}</span>
          </div>
          <div className={styles.disclaimer}>
            You could be debt-free of your home loan this much sooner.
          </div>
        </div>
      </div>

      <hr className={styles.hr} />

      {/* Get Started Button (opens in new tab) */}
      <a
        href="https://www.mortgagematrix.com.au/get-started"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.linkWrapper}
      >
        <button className={styles.infoButton}>
          Suggested Lenders <span className={styles.arrow}>→</span>
        </button>
      </a>

      <div className={styles.disclaimer}>
        If you choose a home loan with one of our panel of lenders, your savings
        may vary based on your specific home loan.
      </div>
    </div>
  );
};

export default RefinanceCalculatorResult;
